/* somnium 2026-02-01 */
function addToCartDuoBox() {
  if( !document.querySelector("body.template-product-available-from") ) return;
  
  const fs = document.querySelector("fieldset.product-form__input--block");
  fs.addEventListener("change", e => {
    const val = e.target.value;    
    const optionId = getVariantByValue(val);

    const frm = document.querySelector("form[data-type='add-to-cart-form']");
    if(frm)
        frm.querySelector("input[name='id']").value = optionId;

    fs.querySelector(".form__label__value").textContent = val;
  })

}

function getVariantByValue(val) {
    const variants = JSON.parse(document.getElementById("product_variants_data").textContent);
    const variant = variants.find(v => v.title === val);
    return variant ? variant.id : null;
}

document.addEventListener('DOMContentLoaded', () => {

  addToCartDuoBox();

});